module.exports = __webpack_public_path__ + "static/media/appointment_grey.da99be2d.svg";